// extracted by mini-css-extract-plugin
export default {"learnButton":"LearnNavButton_learnButton__UjnJz","icon":"LearnNavButton_icon__g-d4P","label":"LearnNavButton_label__Yp8QF"};